/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CandidateOrganisationIndexResponse } from '../types/CandidateOrganisationIndex'

/**
 * GET /candidate-center/organisations
 * @see backend/nexus/modules/CandidateCenter/Http/Controllers/CandidateOrganisationController.php CandidateOrganisationController::index
 */
export async function candidateOrganisationIndex(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateOrganisationIndexResponse>> {
	return axiosInstance.get('/candidate-center/organisations', config)
}
